import { classNames } from "@caprikorn/dynamo-utils";
import type { FC } from "react";

import { getSemanticType } from "@utils/miscellaneous.utils";
import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

import classes from "./Graph.module.css";
import type { GraphProps } from "./Graph.types";

export const Graph: FC<GraphProps> = ({ biggestValue, data }) => {
  const { t } = useCustomTranslation(["main", "common"]);
  return (
    <ul
      aria-label={t("dashboard.graphCard.graph.ariaLabel")}
      className={classes.container}
      data-testid="Graph-wrapper"
    >
      {data.map(
        ({
          consumptionInKwh,
          period,
          month,
          year,
          previousMonthGrowthRatio,
        }) => {
          const height = consumptionInKwh / (biggestValue / 100);

          return (
            <li key={period} className={classes.graph}>
              {consumptionInKwh ? (
                <div
                  className={classNames(
                    classes.bar,
                    classes[
                      getSemanticType(previousMonthGrowthRatio) || "disabled"
                    ],
                  )}
                  data-testid="GraphItemBar"
                  style={{ height }}
                />
              ) : (
                <div
                  className={classNames(classes.bar, classes.disabled)}
                  data-testid="GraphItem-empty"
                />
              )}
              <span
                className={classNames(classes.month, "font-caption")}
                data-testid="GraphItem-label"
              >
                {t("capitalizedDate", {
                  ns: "common",
                  date: new Date(year, month - 1, 1),
                  formatParams: { date: { month: "short" } },
                })}
              </span>
            </li>
          );
        },
      )}
    </ul>
  );
};
